import type { ChatInputHandle } from "@/components/ai/ChatInput.vue";
import {
  integrationConnectionId,
  type IntegrationPill,
} from "@/components/ai/IntegrationPillsBar.vue";

export function insertIntegrationPill(
  chatInput: Pick<ChatInputHandle, "insertIntegration"> | null,
  pill: Pick<IntegrationPill, "integration">
): void {
  chatInput?.insertIntegration(
    pill.integration.integrationKey,
    integrationConnectionId(pill.integration)
  );
}
